import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
export const dmaMiniModelDtoSchema = z.object({
    id: z.number(),
    name: z.string(),
    description: z.string(),
    content: z.string(),
    isOptional: z.boolean(),
    generators: z.unknown(),
    requirements: z.unknown(),
    redefinitions: z.unknown(),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
